<div class="form-group" [class.has-error]="showError">
    <label *ngIf="courseId() && !tariffId()" style="width: 100%">
        <div class="switch-to-pricing-plans">
            {{ "control_course" | translate }}
            <div>
                <ng-container *ngIf="loginEduEnabledForm !== 'login'">
                    <a class="small dashed" (click)="resetSelection()">{{ "switch_to_pricing_plans" | translate }} </a>
                    <ng-template #popTemplate>
                        <a
                            class="d-inline-block mr-3"
                            [attr.href]="knowledgeBaseLink"
                            target="_blank"
                            (click)="popover.toggle()"
                            >{{ "switch_to_pricing_plans_tooltip" | translate }}
                        </a>
                        <span class="color-light small sp-icon icon-outgoing"> </span>
                    </ng-template>
                    <span
                        #popover="bs-popover"
                        class="small sp-icon icon-question color-light hover-effect"
                        [popover]="popTemplate"
                        placement="auto"
                        triggers="focus mouseenter"
                        container="body"
                    ></span>
                </ng-container>
            </div>
        </div>
    </label>
    <ng-container *ngIf="(!courseId() && !tariffId()) || (courseId() && tariffId())">
        <label>
            {{ "courses_and_pricing" | translate }}
        </label>
    </ng-container>
    <ng-container *ngrxLet="eduCourses$; let eduCourses">
        <ng-container *ngIf="eduCourses?.length; else showEmptyCourses">
            <div [tooltip]="tooltipText | translate">
                <select
                    *ngIf="courseId() && !tariffId()"
                    class="form-control"
                    [class.disabled]="isDisabled"
                    (change)="changeEduCourse($event, eduCourses)"
                >
                    <option [value]="null" [selected]="!courseId()" disabled>
                        {{ "control_select_course" | translate }}
                    </option>

                    <option
                        *ngFor="let eduCourse of eduCourses"
                        [value]="eduCourse.id"
                        [selected]="eduCourse?.id === courseId()"
                    >
                        {{ eduCourse.name }}
                    </option>
                </select>

                <ng-select
                    class="sp-ng-select"
                    *ngIf="(!courseId() && !tariffId()) || (courseId() && tariffId())"
                    [items]="eduCourses"
                    bindLabel="name"
                    bindValue="id"
                    groupBy="tariffs"
                    [placeholder]="'control_select_course' | translate"
                    [clearable]="false"
                    [searchable]="false"
                    [disabled]="isDisabled"
                    [ngModel]="tariffId()"
                    (ngModelChange)="changeEduCourseTariff($event, eduCourses)"
                >
                    <ng-template ng-optgroup-tmp let-item="item">
                        {{ item.name }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        {{ item.name }}{{ getCurrencyLabel(item) }}
                    </ng-template>
                </ng-select>
            </div>

            <span *ngIf="!courseId() && showError" class="help-block small">
                {{ "control_select_course" | translate }}
            </span>
        </ng-container>

        <ng-template #showEmptyCourses>
            <div class="alert alert-warning">
                {{ "control_empty_courses" | translate }}
            </div>
        </ng-template>
    </ng-container>
</div>
